import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

function LogoutPage(props) {
    // Zustand store
    const { logout, isAuthenticated } = useAuthStore();
    // const authenticated = isAuthenticated();

    function onLogout() {
        logout(props.history);
        // window.location.reload();
    }
    return (
        <>

            <Link
                to={'#'}
                title="READ MORE"
                className="site-button"
                onClick={onLogout}
                style={{ backgroundColor: '#dc3545', borderColor: '#dc3545', color: '#fff' }}
            >
                <i className="fa fa-lock"></i> Cerrar Sesión
            </Link>
        </>
    )
}

export default withRouter(LogoutPage);